import React from 'react';
import PropTypes from 'prop-types';

import { dig, blank } from 'spiceutils';
import { getSurveyForCdf } from 'utils/AYDAUtils';

import { Multiselect } from 'spicecomponents';

const BacksheetCountries = (props) => {
  if (!dig(props.cdf, ['ExcludeBacksheets']) === true) {
    const showCountry = dig(props.controlList, ['Country', 'Visible']);
    const showCountryList = dig(props.controlList, ['CountryList', 'Visible']);

    let countryControl;
    if (showCountry) {
      countryControl = 'Country';
    } else if (showCountryList) {
      countryControl = 'CountryList';
    }

    if (countryControl) {
      countryControl = props.controlList[countryControl];

      const onChange = (values) => {
        const value = values.map(({ value }) => value).join(',');
        if (!blank(value)) {
          props.updateCDF('BacksheetCountries', value);
        } else {
          props.updateCDF('BacksheetCountries', null);
        }
      };

      return (
        <div>
          <label htmlFor="BacksheetCountries">Countries to include</label>
          <Multiselect
            value={getValueFromProps(props)}
            options={getOptionsFromProps(countryControl, props.cdf)}
            onChange={onChange}
            id="BacksheetCountries"
          />
        </div>
      );
    }
  }
  return null;
};


const getOptionsFromProps = (controlList, cdf) => (
  controlList.Options[getSurveyForCdf(cdf)].map((country) => ({ value: country }))
);

const getValueFromProps = (props) => (
  dig(props.cdf, ['BacksheetCountries', { split: [','] }]) || []
);

BacksheetCountries.propTypes = {
  cdf: PropTypes.object,
  controlList: PropTypes.object,
  updateCDF: PropTypes.func,
};

export default BacksheetCountries;



// WEBPACK FOOTER //
// ./app/components/FormControls/BacksheetCountries/index.js